import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { memo } from 'react';
import { Tags } from '../tags';
import * as Styled from './styles';
import * as SX from './sx';
import type { IndustryTagsProps as Props } from './types';

export const IndustryTags = memo(
  ({ className, title, icon, limitCount = 5, items, config }: Props) => {
    const theme = useTheme();
    return (
      <Styled.Wrapper
        className={classnames('IndustryTags', className)}
        sx={SX.root}
      >
        <Stack direction="row" alignItems="center" gap={1}>
          {icon || (
            <Icon
              name="pajamas-labels"
              color={theme.palette.grey[500]}
              size={20}
            />
          )}

          <Typography variant="body4" color="grey.700" fontWeight={400}>
            {title || 'Industry Tags'}
          </Typography>
        </Stack>

        <Tags
          key="industry-tags"
          items={items}
          limit={limitCount}
          config={config}
          icon="pajamas-labels"
          title={`Industry Tags`}
        />
      </Styled.Wrapper>
    );
  }
);

IndustryTags.displayName = 'IndustryTags';
